import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';
import styles from "./Diagramma.module.css";
import {Radar} from '../../../components/digital_rating/radar/Radar'
import Handler from './handler/Handler'
import {MONTHS} from '../../../utils/const'
import {getSchema, getYears, schoolYear, getPeriod, getMinMax, trashRadar, getInfo, getPhoto, trashInfo} from '../../../actions/radar';
import moment from 'moment'

import { Spinner } from 'react-bootstrap';
import { getInitials } from '../../../utils/smallHelpers';
const Diagramma = 
({
    isTeacher,
    schema,
    scy,
    period,
    idGroup,
    idFaculty, 
    idCourse,
    minMaxRating,
    getSchema, 
    getYears, 
    schoolYear, 
    getPeriod,
    getMinMax,
    loading,
    trashRadar,
    info,
    getInfo,
    mid,
    getPhoto,
    photo,
    trashInfo,
    photoForRadar
}) => {

    const [schemas, setSchema] = useState(localStorage.getItem('schema_st') || null);
    const [year, setYear] = useState(localStorage.getItem('year_st') || null);
    const [month, setMonth] = useState(localStorage.getItem('period_st') || null);
    const [ratingType, setRatingType] = useState(localStorage.getItem('ratingType_st') || -1);
    const [date, setDate] = useState({start: null, end: null});

    const options = {
      responsive: false,
      maintainAspectRatio: false,

      plugins: {
          title: {
              color: "rgba(0, 0, 0, 1)",
              display: true,
              // text: `Цифровой портрет ${!isCompare && data && data[0].lastname || ''} ${!isCompare && data && data[0].firstname.split('')[0] || ''}.${!isCompare && data && data [0].patronymic.split('')[0] || ''}.`
          },
          tooltip: {
              mode: "index",
              intersect: false,
              caretSize: 3,
          },
          legend: {
              labels: {
                  color: "rgba(0, 0, 0, 1)",
              },
          },
      },
      scales: {
          xAxes: {
              ticks: {
                  color: 'rgba(0, 0, 0, 1)', 
              }
          },
          yAxes: {
              ticks: {
                  color: 'rgba(0, 0, 0, 1)', 
                  beginAtZero: true,
                  stepSize: 0.25
              }
          },
      }
  };

    useEffect(() => {
        getYears();
        schoolYear(); 
    }, [])

    useEffect(() => {
      mid && getPhoto(mid)
    }, [mid])
    
    useEffect(() => {
        if (year) {
          getSchema(year)
          getPeriod(year)
        } else {
          setSchema(null);
          setMonth(null);
        }
    }, [year])
    
    const handleMinMax = () => {
      if((scy && year && month && schemas && ratingType !== -1 && idGroup)) {
        getMinMax(year, month, schemas, ratingType, findType(ratingType), scy);
        getInfo(schemas, idGroup, year, month, scy);
      } else {
        trashRadar();
        trashInfo();
      }
    }

    useEffect(() => {
      if((scy && year && month && schemas && ratingType !== -1 && idGroup)) {
        getMinMax(year, month, schemas, ratingType, findType(ratingType), scy);
        getInfo(schemas, idGroup, year, month, scy);
      } else {
        trashRadar();
        trashInfo();
      }
    }, [scy, year, month, schemas, ratingType, idGroup])
    
    
    const findType = (ratingType) => {
      if (ratingType == 1) {
        return idGroup;
      } else if (ratingType == 2) {
        return idCourse;
      } else if (ratingType == 3) {
        return idFaculty;
      } else if (ratingType == 4) {
        return 0
      }
    }

    const handleRatingType = (e) => {
      setRatingType(e.target.value);
      localStorage.setItem('ratingType_st', e.target.value);      
    }

    const handleTrash = () => {
      setYear(null);
      setSchema(null);
      setMonth(null);
      setRatingType(-1)
      localStorage.removeItem('schema_st');
      localStorage.removeItem('year_st');
      localStorage.removeItem('period_st');
      localStorage.removeItem('ratingType_st');
      trashRadar();
      trashInfo();
    }

    const getDate = (date, month, type, dateTerm = null) => {
      let newDateList = '';
      if (month > 6) {
        newDateList = date.begdate?.split('-');
      } else {
        newDateList = date.enddate?.split('-')
      }
      let newDateTerm = dateTerm?.split('.');
      let newDate = '';
        if (!dateTerm) {
          newDate = `${month + '.1.' + newDateList[2]}`
        } else if (dateTerm) {
          newDate = `${newDateTerm[1] + '.' + newDateTerm[0] + '.' + newDateTerm[2]}`;
        }

      if (type === 'start' && !dateTerm) {
        return moment(newDate).startOf('month').format("D MMMM YYYY");
      }

      if (type === 'end' && !dateTerm) {
        return moment(newDate).endOf('month').format("D MMMM YYYY");
      }

      if (type === 'start' && dateTerm) {
        return moment(newDate).format("D MMMM YYYY");
      }

      if (type === 'end' && dateTerm) {
        return moment(newDate).format("D MMMM YYYY");
      }
      
    }

    useEffect(() => {
      if (month?.split('').length > 2) {
        let endMonth = month
                        .substring(0, month.length - 1)
                        .replaceAll(',', '.');
        let startMonth = endMonth && period && period
                       ?.terms
                       ?.filter(el => el.term_end == endMonth)[0]?.term_begin;

        setDate({start: startMonth, end: endMonth})
      }
    
      return () => {
        setDate({start: null, end: null})
      }
    }, [month, period])

    const RadarTitle = () => {
      if (!scy || !info) return 'Обобщенный рейтинг';
      const curUser = info.find(el => el.mid == mid)
      const fio = getInitials(`${curUser?.lastname} ${curUser?.firstname} ${curUser?.patronymic}`)
      
      const curYear = scy.find(el => el?.xp_key == year)
      const startDate = getDate(curYear, month, 'start', date.start)
      const endDate = getDate(curYear, month, 'end', date.end)
      return `Обобщенный рейтинг ${fio} c ${startDate} по ${endDate}`
    }

  return (
    <div className={styles.wrapper}>
      {!isTeacher && (
        <div className={styles.filtersCard}>
          <div className={styles.filters}>
            <Handler name='Год' localName='year_st' handle={year} setHandle={setYear} options={scy}/>
            <Handler name='Схема' localName='schema_st' handle={schemas} setHandle={setSchema} options={schema}/>
            <Handler name='Месяц' localName='period_st' handle={month} setHandle={setMonth} options={MONTHS} period={period}/>
          </div>

          <div className={styles.radios} onChange={(e) => handleRatingType(e)}>
            <span className={styles.rating_span}>
                <input type="radio" name={ratingType} value={1} checked={ratingType == 1}/>
                <label for={1}>рейтинг по группе</label>
            </span>
            <span className={styles.rating_span}>
                <input type="radio" name={ratingType} value={2} checked={ratingType == 2}/>
                <label for={2}>рейтинг по курсу</label>
            </span>
            <span className={styles.rating_span}>
                <input type="radio" name={ratingType} value={3} checked={ratingType == 3}/>
                <label for={3}>рейтинг по факультету</label>
            </span>
            <span className={styles.rating_span}>
                <input type="radio" name={ratingType} value={4} checked={ratingType == 4}/>
                <label for={4}>рейтинг по ВУЗу</label>
            </span>
          </div>

          <div className={styles.buttons}>
            <button className={styles.btnUpdate} onClick={handleMinMax}>Обновить</button>
            <button className={styles.btnReset} onClick={handleTrash}>Сброс</button>
          </div>
        </div>
      )}

      {!isTeacher && (
        <div className={styles.radarCard}>
          <div className={styles.radarHeader}>
            <h3>
              <RadarTitle/>
            </h3>
          </div>

          <div className={styles.radarBody}>
            {info && info.length > 0 && minMaxRating && !loading &&
              <div className={styles.radar}>
                <Radar
                  data={info}
                  mid={mid}
                  minMax={minMaxRating}
                  imageUrl={photoForRadar}
                  />
              </div>
            }

            {loading &&
              <div className={styles.spinnerWrap}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            }

            {(!loading && (schemas == null || year == null || month == null || ratingType == -1)) &&
              <div className={styles.hint}>
                <i>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"></path><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path></svg>
                </i><p>Задайте все параметры диаграммы</p>
              </div>
            }
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
    schema: state.radar.schema,
    years: state.radar.years,
    scy: state.radar.scy,
    period: state.radar.period,    
    minMaxRating: state.radar.minMaxRating,
    idGroup: state.auth.gid,
    idFaculty: state.lk.data.facultyid,
    idCourse: state.lk.data.yeducationyearid,
    loading: state.radar.loading,
    info: state.radar.info,
    mid: state.auth.mid,
    photo: state.radar.photo
  });
   
  export default connect(mapStateToProps, { 
    getSchema,
    getYears, 
    schoolYear, 
    getPeriod,
    getMinMax,
    trashRadar,
    getInfo,
    getPhoto,
    trashInfo
  })(Diagramma);
